import { Heading, List } from 'yoso';
import { PostCard } from '~/components/Card/PostCard/PostCard';
import { T } from '~/components/I18n';
import checkBoard from '~/components/Icon/checkBoard.png';
import store from '~/components/Icon/store.png';
import styles from './HowToEarn.module.scss';

export const HowToEarn = () => (
  <div className={styles.root}>
    <div className={styles.header}>
      <Heading level={4} className={styles.title}>
        <T name="citizen_levelup_don_collection_title" />
      </Heading>
    </div>
    <div className={styles.body}>
      <List className={styles.list}>
        <li>
          <PostCard
            image={<img src={checkBoard} alt="Check-in" width={60} height={60} />}
            title={<T name="citizen_levelup_don_collection_title1" />}
            description={<T name="citizen_levelup_don_collection_desc1" />}
          />
        </li>
        <li>
          <PostCard
            image={<img src={store} alt="Purchase amount" width={60} height={60} />}
            title={<T name="citizen_levelup_don_collection_title2" />}
            description={<T name="citizen_levelup_don_collection_desc2" />}
          />
        </li>
      </List>
    </div>
  </div>
);
